import { Heart } from "lucide-react";
import ContentTabs from "../components/ContentTabs";
import ImageCarousel from "../components/ImageCarousel";
import CircularProgress from "../components/CircularProgress";
import TeamMembersCard from "../components/TeamMembersCard";
import FundraisingTeamCard from "../components/FundraisingTeamCard";
import SupportersCard from "../components/SupportersCard";
import SocialIcons from "../components/SocialIcons"; 

const Campaigndetailspage = () => {
  const raised = 75000;
  const goal = 100000;
  const percentage = Math.round((raised / goal) * 100);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
   <div className="min-h-screen bg-white">

      <main className="container mx-auto px-4 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Left */}
          <div className="lg:col-span-7 animate-fade-up">
            <ImageCarousel />
            <div className="mt-6">
              <ContentTabs />
            </div>
          </div>

          {/* Right */}
          <div
            className="lg:col-span-5 space-y-6 animate-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            <div className="card-elevated p-8 flex flex-col items-center">
              <CircularProgress
                percentage={percentage}
                raised={raised}
                goal={goal}
              />

              <div className="mt-6 text-center">
                <p className="text-sm text-muted-foreground uppercase tracking-wide">
                  Total Count
                </p>
                <p className="text-2xl font-heading font-bold text-foreground mt-1">
                  {formatCurrency(raised)}
                </p>
                <p className="text-sm text-muted-foreground">
                  of {formatCurrency(goal)} goal
                </p>
              </div>

              {/* Replaced custom Button with plain Tailwind button */}
              <button
                className="w-full mt-6 flex items-center justify-center gap-2 px-4 py-2 bg-teal-600 text-white font-semibold rounded-md hover:bg-teal-700 transition"
              >
                <Heart size={20} />
                Donate Now
              </button>

              <div className="mt-6">
                <p className="text-xs text-muted-foreground text-center mb-3">
                  Share this campaign
                </p>
                <SocialIcons />
              </div>
            </div>

            <TeamMembersCard />
            <FundraisingTeamCard />
            <SupportersCard />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Campaigndetailspage;
